import '@fontsource-variable/roboto'

import { ReactComponent as IconArrow } from 'assets/icon/Arrow 1 (Stroke).svg'
import { ReactComponent as Anticscam } from 'assets/icon/service/ico_antiscam.svg'
import MoreButton from 'shared/components/common/MoreButton'
import STYLE_GUIDE from 'shared/constants/color'
import styled from 'styled-components'
import { Autoplay, EffectFade } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import PartnerChip from './PartnerChip'

const CsrCardComponent = (props) => {
  const { data, isMoreOpen, handleMoreBtn } = props
  const { Idx, Title, Contents, History, ImgUrl, QnaUrl, HomeUrl, Partner } = data

  const years = [...new Set(History?.map((el) => el.Year))]
  const isShowMoreBtn = years.length > 3 && !isMoreOpen
  const historyList = isMoreOpen
    ? History
    : History?.filter((el) => years.slice(0, 3).includes(el.Year))
  const description = Contents?.split('(*')?.[0]
  const subDescription = Contents?.split(description)?.[1]

  return (
    <CardWrap>
      <div className="card_item_wrapper">
        <Swiper
          slidesPerView={1}
          loop={true}
          effect={'fade'}
          modules={[Autoplay, EffectFade]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false, // 쓸어 넘기거나 버튼 클릭 시 자동 슬라이드 정지.
          }}
          fadeEffect={{ crossFade: true }}
        >
          {ImgUrl?.map((img, index) => (
            <SwiperSlide key={index}>
              <div className="card_image" style={{ backgroundImage: `url(${img})` }} />
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="card_container">
          <div className="card_header">
            <h3 className="card_title">{Title}</h3>
            <div>
              <div className="card_description">{description}</div>
              {!!subDescription && <div className="card_sub_description">{subDescription}</div>}
            </div>
          </div>
          {History?.length > 0 && (
            <div className="card_timeline_container">
              {historyList.map((historyItem, historyIdx) => (
                <div className="card_timeline_item" key={historyIdx}>
                  <div
                    className="card_timeline_year"
                    style={
                      historyList?.[historyIdx - 1]?.Year === historyItem?.Year
                        ? { opacity: 0 }
                        : {}
                    }
                  >
                    {historyItem?.Year}
                  </div>
                  <div className="card_timeline_text">{historyItem?.HistoryContents}</div>
                </div>
              ))}
            </div>
          )}
          {Partner?.length > 0 && (
            <div className="card_chip_container">
              {Partner?.map((partnerItem, partnerIdx) => (
                <PartnerChip name={partnerItem} key={partnerIdx} />
              ))}
            </div>
          )}
          {(!!QnaUrl || !!HomeUrl) && (
            <div className="card_chip_container">
              {!!QnaUrl && (
                <a href={QnaUrl} target="_blank" rel="noopener noreferrer" className="url_btn">
                  문의하기 <IconArrow />
                </a>
              )}
              {!!HomeUrl && HomeUrl?.includes('www.antiscam.co.kr') && (
                <a href={HomeUrl} target="_blank" rel="noopener noreferrer" className="url_btn">
                  <Anticscam className="antiscam" />
                  스마트피싱보호 HOME <IconArrow />
                </a>
              )}
            </div>
          )}
        </div>
      </div>
      {isShowMoreBtn && <MoreButton onClick={() => handleMoreBtn(Idx)} />}
    </CardWrap>
  )
}

export default CsrCardComponent

const CardWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 120px;

  @media screen and (max-width: 1199px) {
    gap: 80px;
  }

  .card_item_wrapper {
    display: flex;
    flex-direction: row;
    gap: 80px;

    @media screen and (max-width: 1919px) {
      flex-direction: column;
    }

    @media screen and (max-width: 1199px) {
      gap: 30px;
    }
  }

  .swiper {
    flex: 1;
    margin: 0;
    height: 500px;
    border-radius: 40px;

    @media screen and (max-width: 1919px) {
      flex: unset;
      height: 625px;
    }

    @media screen and (max-width: 1199px) {
      height: 477.5px;
      border-radius: 30px;
    }

    @media screen and (max-width: 883px) {
      height: 200px;
    }

    .swiper-wrapper .swiper-slide {
      width: 100%;
      height: auto;
    }
  }

  .card_image {
    //flex: 1;
    width: 100%;
    height: 500px;
    background-color: lightgray;
    background-position: 50% 50%;
    background-size: cover;
    background-repeat: no-repeat;

    @media screen and (max-width: 1919px) {
      //flex: unset;
      height: 625px;
    }

    @media screen and (max-width: 1199px) {
      height: 477.5px;
    }

    @media screen and (max-width: 883px) {
      height: 200px;
    }
  }

  .card_container {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .card_header {
    display: flex;
    flex-direction: column;
    gap: 30px;

    @media screen and (max-width: 1199px) {
      gap: 20px;
    }
  }

  .card_title {
    color: ${STYLE_GUIDE.COLOR.black1};
    font-size: 36px;
    font-weight: 700;
    line-height: 48px;
    white-space: pre-line;

    @media screen and (max-width: 1199px) {
      font-size: 24px;
      line-height: 36px;
    }
  }

  .card_description {
    color: ${STYLE_GUIDE.COLOR.black1};
    font-size: 22px;
    font-weight: 400;
    line-height: 34px;
    white-space: pre-line;

    @media screen and (max-width: 1199px) {
      font-size: 18px;
      line-height: 30px;
      white-space: unset;
    }
  }

  .card_sub_description {
    margin-top: 6px;
    color: ${STYLE_GUIDE.COLOR.black4};
    font-size: 18px;
    font-weight: 400;
    line-height: 30px;

    @media screen and (max-width: 1199px) {
      font-size: 14px;
      line-height: 24px;
    }
  }

  .card_timeline_container {
    display: flex;
    flex-direction: column;
    gap: 30px;
    margin-top: 80px;

    @media screen and (max-width: 1199px) {
      gap: 20px;
      margin-top: 30px;
    }
  }

  .card_timeline_item {
    display: flex;
    gap: 20px;

    @media screen and (max-width: 1199px) {
      gap: 10px;
    }
  }

  .card_timeline_year {
    font-family: 'Roboto Variable', sans-serif;
    color: ${STYLE_GUIDE.COLOR.black1};
    font-size: 28px;
    font-weight: 500;
    line-height: 38px;

    @media screen and (max-width: 1199px) {
      font-size: 16px;
      line-height: 30px;
    }
  }

  .card_timeline_text {
    color: ${STYLE_GUIDE.COLOR.black1};
    font-size: 22px;
    font-weight: 400;
    line-height: 34px;

    @media screen and (max-width: 1199px) {
      font-size: 16px;
      line-height: 30px;
    }
  }

  .card_chip_container {
    display: flex;
    gap: 20px;
    margin-top: 50px;
    flex-wrap: wrap;

    @media screen and (max-width: 1199px) {
      gap: 10px;
      margin-top: 30px;
    }
  }

  .url_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 20px 30px;
    border: 1.5px solid ${STYLE_GUIDE.COLOR.black3};
    border-radius: 100px;
    color: ${STYLE_GUIDE.COLOR.black1};
    font-size: 24px;
    font-weight: 700;
    line-height: 36px;
    cursor: pointer;

    & > svg:last-child {
      transform: translate(-2px, 2px);
    }

    &:hover {
      & > svg:last-child {
        transform: translate(8px, -8px);
        transition: 0.2s;
      }
    }

    @media screen and (max-width: 1199px) {
      gap: 4px;
      padding: 6px 16px;
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;

      & > svg:last-child {
        padding-top: 5px;
        width: 7px;
        height: 7px;
        transform: unset;
      }

      & > .antiscam {
        padding: unset;
        width: 16px;
        height: 16px;
      }

      &:hover {
        & > svg:last-child {
          transform: translate(6px, -6px);
          transition: 0.2s;
        }
      }
    }
  }
`
